<template>
  <div>
    <alert
      v-if="alertVisible"
      :message="alertMessage"
      :type="alertType">
    </alert>
    <main-layout
      controlsBg="light"
      customControls
      :hasControlsBar="false"
      :breadcrumb="getBreadcrumb">
      <div class="container">
        <grid-row column-align="center">
          <grid-col col-size="4">
            <div class="header-wrapper margin-top-xl margin-bottom-xxl">
              <div class="title-wrapper">
                <h1 class="header header-title">
                  <chevron
                    @click="$router.push({name: 'Workspace'})"/>
                  {{ $t('menu.csvIngest') }}
                </h1>
              </div>
            </div>
          </grid-col>
        </grid-row>

        <grid-row
          column-align="center">
          <grid-col
            col-size="4">
            <h2
              class="margin-bottom-s">
              Variables</h2>
            <p>&#128196; CSV</p>
          </grid-col>
        </grid-row>

        <grid-row
          column-align="center">
          <grid-col
            col-size="4">
            <div
              class="margin-bottom-xxl">
              <btn-pill
                class="margin-right-l"
                v-on:click="showModal = true"
                btn-size="s"
                btn-type="secondary">
                <font-awesome-icon
                  :icon="icon.users"
                  class="table-icon-disabled"/>
              </btn-pill>
              <span>{{ selectedUser !== null ? selectedUser.name : '' }}</span>
            </div>
          </grid-col>
        </grid-row>

        <grid-row column-align="center">
          <grid-col col-size="4">
            <div>
              <btn-input-file
                :disabled="selectedUser === null"
                class="button-uploader"
                btn-text="upload"
                btn-size="s"
                @change="uploadCsv" />
              <btn-pill
                @click="downloadExampleCsv()"
                btn-text="download"
                btn-size="s"/>
            </div>
          </grid-col>
        </grid-row>

      </div>
    </main-layout>
    <add-user-modal
      v-if="showModal"
      :users="users"
      v-on:addUser="addUser"
      v-on:cancel="showModal = false" />
  </div>
</template>

<script>
import MainLayout from '@/layouts/MainLayout';
import BtnInputFile from '@/components/shared/buttons/BtnInputFile';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import Alert from '@/components/shared/alert/Alert';
import Chevron from '@/components/shared/Chevron';
import BtnPill from '@/components/shared/buttons/BtnPill';
import Radio from '@/components/shared/forms/Radio';
import AddUserModal from '@/components/group/AddUserModal';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import {faUsers} from '@fortawesome/pro-regular-svg-icons';

import userApi from '@/api/user';
import csvIngestApi from '@/api/csvIngest';

export default {
  name: 'CsvIngest',
  components: {
    AddUserModal,
    Radio,
    BtnPill,
    Chevron,
    MainLayout,
    GridRow,
    GridCol,
    BtnInputFile,
    Alert,
    FontAwesomeIcon
  },
  data () {
    return {
      showModal: false,
      selectedUser: null,
      users: [],
      /* UI controls */
      alertVisible: false,
      alertMessage: '',
      alertType: '', // error, warning, success
      icon: {
        users: faUsers
      }
    };
  },
  created () {
    userApi.getUsers(this).then((users) => { this.users = users.filter(user => user.enabled); });
  },
  computed: {
    getBreadcrumb () {
      return [
        { name: this.$t('menu.workspace'), link: '/workspace' },
        { name: this.$t('menu.csvIngest'), disabled: true }
      ];
    }
  },
  methods: {
    uploadCsv (event) {
      const file = event.target.files[0];
      csvIngestApi.uploadCsvForUser(this, this.selectedUser.name, file)
        .then(() => this.showAlert('OK', 'success'))
        .catch((error) => this.showAlert(error.data.message, 'error'));
    },
    downloadExampleCsv () {
      const data = `timestamp,variable,value
1577836800000,example,0.0
1577836801000,example,1.0
1577836802000,example,2.0
1577836800000,other,10`;
      this.downloadCsv('example.csv', data);
    },
    downloadCsv (name, data) {
      const hiddenElement = document.createElement('a');
      hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(data);
      hiddenElement.target = '_blank';
      hiddenElement.download = name;
      hiddenElement.click();
    },
    addUser (user) {
      this.showModal = false;
      this.selectedUser = user;
    },
    showAlert (message, type) {
      this.alertVisible = true;
      this.alertMessage = message;
      this.alertType = type;
      setTimeout(() => {
        this.alertVisible = false;
      }, 2000);
    }
  }
};
</script>

<style lang="scss">
  @import "src/stylesheets/variables";
 </style>



// WEBPACK FOOTER //
// src/layouts/csv/CsvIngest.vue